import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FlowsDisplayGridRowDataFragmentGql } from './FlowsDisplayGridRowDataFragmentGql';

export const VirtualConnectionDownstreamFlowsFilteredByTableQueryGql: DocumentNode = gql`
query VirtualConnectionDownstreamFlowsFilteredByTableQuery(
  $vizportalUrlId: String!,
  $selectedTableId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: FlowSortOrder!
) {
  virtualConnections(filter: { vizportalUrlId: $vizportalUrlId }) {
    tablesConnection(filter: { id: $selectedTableId }) {
      nodes {
        downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...FlowsDisplayGridRowDataFragment
          }
        }
      }
    }
  }
}
${FlowsDisplayGridRowDataFragmentGql}
`;
